import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const TeamInfosContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  padding: "8px 0",
  minHeight: "204px",
  width: "100%",
  "&:hover": {
    backgroundColor: colors.gray100,
  },
  gap: "4px 0",

  "&:not(:last-of-type)": {
    borderBottom: `1px solid ${colors.gray200}`,
  },
}));

export const Header = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",

  padding: "8px 16px",
  width: "100%",
});

export const TeamsInfosWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const TeamsInfos = styled("div")(() => ({
  padding: "4px 0 4px 6px",
}));

export const Title = styled("span")(() => ({
  color: colors.gray800,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "20px",
  letterSpacing: "0.1px",
}));
